import $ from "jquery";
import "bootstrap";
import 'iscroll';
import 'jquery-drawer';
import ScrollReveal from "scrollreveal";

$(document).ready(function () {
    ScrollReveal().reveal(".headlines", {
        distance: "100px",
        origin: "bottom",
        viewFactor: "0.2",
    });
    // ScrollReveal().reveal(".shingaku", {
    //     distance: "100px",
    //     origin: "bottom",
    //     viewFactor: "0.4",
    // });
    // ScrollReveal().reveal('.kyoiku, .kosu, .bosyu', {
    //     distance: "100px",
    //     origin: "bottom",
    //     viewFactor: "0.2",
    // });

    $(".drawer").drawer();

    $(".sidebar-dropdown > a").click(function () {
        $(".sidebar-submenu").slideUp(200);
        if ($(this).parent().hasClass("active")) {
            $(".sidebar-dropdown").removeClass("active");
            $(this).parent().removeClass("active");
        } else {
            $(".sidebar-dropdown").removeClass("active");
            $(this).next(".sidebar-submenu").slideDown(200);
            $(this).parent().addClass("active");
        }
    });

    $("#close-sidebar").click(function () {
        $(".page-wrapper").removeClass("toggled");
    });
    $("#show-sidebar").click(function () {
        $(".page-wrapper").addClass("toggled");
    });

});
